export default "__VITE_ASSET__DVx6D7ZA__"